import type { HTMLAttributes } from "react";
import { cn } from "./cn";

interface SkeletonProps extends HTMLAttributes<HTMLDivElement> {
  width?: string | number;
  height?: string | number;
  rounded?: "sm" | "md" | "lg" | "xl" | "full";
}

const ROUND = {
  sm: "rounded-sm",
  md: "rounded-md",
  lg: "rounded-lg",
  xl: "rounded-xl",
  full: "rounded-full",
} as const;

export function Skeleton({
  width,
  height,
  rounded = "md",
  className,
  style,
  ...rest
}: SkeletonProps) {
  return (
    <div
      role="presentation"
      aria-hidden
      className={cn("skeleton", ROUND[rounded], className)}
      style={{
        width,
        height: height ?? "0.9rem",
        ...style,
      }}
      {...rest}
    />
  );
}
